import { Link } from 'react-router-dom';
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';

export default function ContactoPage() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    servicio: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('nombre', formData.nombre);
      formBody.append('email', formData.email);
      formBody.append('telefono', formData.telefono);
      formBody.append('servicio', formData.servicio);
      formBody.append('mensaje', formData.mensaje);

      const response = await fetch('https://readdy.ai/api/form/d4arcoch4thklmcv2pkg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          servicio: '',
          mensaje: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="min-h-screen flex flex-col">
        <Header />

        {/* Hero */}
        <section className="bg-gradient-to-br from-[#544E13] to-[#3a3610] text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Contacto</h1>
            <p className="text-xl text-gray-200 max-w-3xl">
              Estamos aquí para ayudarte. Contacta con RESTAURAX y recibe atención profesional inmediata para tu restauración post incendio en Hospitalet de Llobregat y Barcelona.
            </p>
          </div>
        </section>

        {/* Introducción */}
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-6">
              Solicita tu presupuesto gratuito sin compromiso
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              En <strong>RESTAURAX</strong> entendemos la urgencia y el estrés que supone enfrentarse a las consecuencias de un incendio. Por eso, nuestro equipo de profesionales está disponible 24 horas al día, 7 días a la semana para atender tu llamada y ofrecerte una solución rápida y eficaz en <strong>Hospitalet de Llobregat</strong>, Barcelona y toda el área metropolitana. Conoce más sobre <Link to="/empresa" className="text-[#F2D70A] hover:text-[#544E13] font-semibold underline">nuestra empresa y experiencia</Link> de más de 15 años en el sector.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Ofrecemos presupuestos completamente gratuitos y sin ningún tipo de compromiso. Nuestros técnicos se desplazarán a tu propiedad para realizar una evaluación exhaustiva de los daños causados por el incendio y elaborar un plan de actuación personalizado que incluya todos los servicios necesarios: <strong>limpieza de hollín</strong>, <strong>eliminación de olores</strong>, <strong>desescombro</strong>, <strong>tratamiento de ozono</strong>, <strong>pintura final</strong> y <strong>pequeñas reparaciones</strong>. Puedes conocer en detalle todos nuestros <Link to="/servicios" className="text-[#F2D70A] hover:text-[#544E13] font-semibold underline">servicios especializados</Link>.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Confía en los expertos con más de 15 años de experiencia en <strong>restauración post incendio en Barcelona</strong>. Rellena el formulario de contacto, llámanos directamente o escríbenos por WhatsApp. Estamos preparados para ayudarte a recuperar tu hogar o negocio lo antes posible. Si tienes dudas sobre nuestros procesos, consulta nuestras <Link to="/faq" className="text-[#F2D70A] hover:text-[#544E13] font-semibold underline">preguntas frecuentes</Link>.
            </p>
          </div>
        </section>

        {/* Contacto Principal */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-12">
              {/* Formulario */}
              <div className="bg-white rounded-lg shadow-xl p-8">
                <h3 className="text-2xl font-bold text-[#544E13] mb-6">
                  Formulario de contacto
                </h3>
                <form id="contacto-form" onSubmit={handleSubmit} data-readdy-form>
                  <div className="space-y-4">
                    <div>
                      <label htmlFor="nombre" className="block text-sm font-semibold text-gray-700 mb-2">
                        Nombre completo *
                      </label>
                      <input
                        type="text"
                        id="nombre"
                        name="nombre"
                        value={formData.nombre}
                        onChange={(e) => setFormData({...formData, nombre: e.target.value})}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#F2D70A] focus:border-transparent text-sm"
                        placeholder="Tu nombre y apellidos"
                      />
                    </div>

                    <div>
                      <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                        Email *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#F2D70A] focus:border-transparent text-sm"
                        placeholder="tu@email.com"
                      />
                    </div>

                    <div>
                      <label htmlFor="telefono" className="block text-sm font-semibold text-gray-700 mb-2">
                        Teléfono *
                      </label>
                      <input
                        type="tel"
                        id="telefono"
                        name="telefono"
                        value={formData.telefono}
                        onChange={(e) => setFormData({...formData, telefono: e.target.value})}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#F2D70A] focus:border-transparent text-sm"
                        placeholder="690 22 09 44"
                      />
                    </div>

                    <div>
                      <label htmlFor="servicio" className="block text-sm font-semibold text-gray-700 mb-2">
                        Servicio que necesitas *
                      </label>
                      <select
                        id="servicio"
                        name="servicio"
                        value={formData.servicio}
                        onChange={(e) => setFormData({...formData, servicio: e.target.value})}
                        required
                        className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#F2D70A] focus:border-transparent text-sm appearance-none bg-white"
                      >
                        <option value="">Selecciona un servicio</option>
                        <option value="Limpieza de hollín">Limpieza de hollín en superficies</option>
                        <option value="Eliminación de olores">Eliminación de malos olores</option>
                        <option value="Desescombro">Desescombro y vaciado</option>
                        <option value="Tratamiento de ozono">Tratamiento de ozono</option>
                        <option value="Pintura">Pintura final</option>
                        <option value="Reparaciones">Pequeñas reparaciones</option>
                        <option value="Servicio completo">Servicio completo de restauración</option>
                        <option value="Otro">Otro servicio</option>
                      </select>
                    </div>

                    <div>
                      <label htmlFor="mensaje" className="block text-sm font-semibold text-gray-700 mb-2">
                        Mensaje *
                      </label>
                      <textarea
                        id="mensaje"
                        name="mensaje"
                        value={formData.mensaje}
                        onChange={(e) => {
                          if (e.target.value.length <= 500) {
                            setFormData({...formData, mensaje: e.target.value});
                          }
                        }}
                        required
                        rows={5}
                        maxLength={500}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#F2D70A] focus:border-transparent text-sm resize-none"
                        placeholder="Cuéntanos qué ha ocurrido y qué necesitas. Máximo 500 caracteres."
                      ></textarea>
                      <p className="text-xs text-gray-500 mt-1">
                        {formData.mensaje.length}/500 caracteres
                      </p>
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full bg-[#F2D70A] text-[#544E13] px-8 py-4 rounded-lg font-bold text-lg hover:bg-[#544E13] hover:text-white transition-all whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isSubmitting ? 'Enviando...' : 'Solicitar Presupuesto Gratis'}
                    </button>

                    {submitStatus === 'success' && (
                      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                        <p className="text-green-800 text-sm font-semibold">
                          ¡Mensaje enviado correctamente! Nos pondremos en contacto contigo lo antes posible.
                        </p>
                      </div>
                    )}

                    {submitStatus === 'error' && (
                      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                        <p className="text-red-800 text-sm font-semibold">
                          Ha ocurrido un error. Por favor, inténtalo de nuevo o llámanos directamente al 690 22 09 44.
                        </p>
                      </div>
                    )}
                  </div>
                </form>
              </div>

              {/* Información de Contacto */}
              <div>
                <div className="bg-[#544E13] text-white rounded-lg p-8 mb-8">
                  <h3 className="text-2xl font-bold mb-6">Información de contacto</h3>
                  
                  <div className="space-y-6">
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-phone-line text-2xl text-[#544E13]"></i>
                      </div>
                      <div>
                        <h4 className="font-bold mb-1">Teléfono 24/7</h4>
                        <a href="tel:690220944" className="text-[#F2D70A] text-xl font-bold hover:text-white transition-colors">
                          690 22 09 44
                        </a>
                        <p className="text-gray-300 text-sm mt-1">
                          Disponible las 24 horas para emergencias
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-mail-line text-2xl text-[#544E13]"></i>
                      </div>
                      <div>
                        <h4 className="font-bold mb-1">Email</h4>
                        <a href="mailto:info@restaurax.com" className="text-[#F2D70A] hover:text-white transition-colors">
                          info@restaurax.com
                        </a>
                        <p className="text-gray-300 text-sm mt-1">
                          Respuesta en menos de 24 horas
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-map-pin-line text-2xl text-[#544E13]"></i>
                      </div>
                      <div>
                        <h4 className="font-bold mb-1">Ubicación</h4>
                        <p className="text-gray-300">
                          Hospitalet de Llobregat<br />
                          Barcelona, España
                        </p>
                        <p className="text-gray-300 text-sm mt-1">
                          Servicio en toda el área metropolitana
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-time-line text-2xl text-[#544E13]"></i>
                      </div>
                      <div>
                        <h4 className="font-bold mb-1">Horario</h4>
                        <p className="text-gray-300">
                          <strong>Emergencias:</strong> 24/7<br />
                          <strong>Oficina:</strong> Lunes a Viernes<br />
                          9:00 - 19:00h
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-[#F2D70A] rounded-lg p-8">
                  <h3 className="text-2xl font-bold text-[#544E13] mb-4">
                    ¿Necesitas atención inmediata?
                  </h3>
                  <p className="text-[#544E13] mb-6">
                    Para emergencias post incendio, llámanos directamente. Nuestro equipo está preparado para actuar de inmediato en Hospitalet de Llobregat y Barcelona.
                  </p>
                  <a 
                    href="tel:690220944"
                    className="block bg-[#544E13] text-white px-8 py-4 rounded-lg font-bold text-center hover:bg-white hover:text-[#544E13] transition-all whitespace-nowrap cursor-pointer mb-4"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    Llamar Ahora: 690 22 09 44
                  </a>
                  <a 
                    href={`https://wa.me/34690220944?text=${encodeURIComponent('Hola, necesito información sobre servicios de limpieza y restauración post incendio.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block bg-[#25D366] text-white px-8 py-4 rounded-lg font-bold text-center hover:bg-[#128C7E] transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-line mr-2"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Zona de Servicio */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-6 text-center">
              Nuestra zona de servicio en Barcelona
            </h2>
            <p className="text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
              Ofrecemos servicios de <strong>limpieza y restauración post incendio</strong> en toda el área metropolitana de Barcelona, con especial presencia en las siguientes localidades.
            </p>

            <div className="grid md:grid-cols-2 gap-12 items-center mb-12">
              <div>
                <h3 className="text-2xl font-bold text-[#544E13] mb-6">Municipios que atendemos</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex items-center space-x-2">
                    <i className="ri-map-pin-fill text-[#F2D70A]"></i>
                    <span className="text-gray-700">Hospitalet de Llobregat</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-map-pin-fill text-[#F2D70A]"></i>
                    <span className="text-gray-700">Barcelona ciudad</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-map-pin-fill text-[#F2D70A]"></i>
                    <span className="text-gray-700">Cornellà de Llobregat</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-map-pin-fill text-[#F2D70A]"></i>
                    <span className="text-gray-700">Esplugues de Llobregat</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-map-pin-fill text-[#F2D70A]"></i>
                    <span className="text-gray-700">Sant Just Desvern</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-map-pin-fill text-[#F2D70A]"></i>
                    <span className="text-gray-700">Sant Feliu de Llobregat</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-map-pin-fill text-[#F2D70A]"></i>
                    <span className="text-gray-700">El Prat de Llobregat</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-map-pin-fill text-[#F2D70A]"></i>
                    <span className="text-gray-700">Viladecans</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-map-pin-fill text-[#F2D70A]"></i>
                    <span className="text-gray-700">Sant Boi de Llobregat</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-map-pin-fill text-[#F2D70A]"></i>
                    <span className="text-gray-700">Y municipios cercanos</span>
                  </div>
                </div>
                <p className="text-gray-700 mt-6 leading-relaxed">
                  Nuestro equipo puede desplazarse rápidamente a cualquier punto de la provincia de Barcelona para atender emergencias de <strong>restauración post incendio</strong>. Si tu localidad no aparece en la lista, no dudes en contactarnos para confirmar disponibilidad.
                </p>
              </div>

              <div className="relative h-96 rounded-lg overflow-hidden shadow-xl">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95777.97502058595!2d2.0506!3d41.3598!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a4a2f8b5679c45%3A0x6c8b1b1b1b1b1b1b!2sHospitalet%20de%20Llobregat%2C%20Barcelona!5e0!3m2!1ses!2ses!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mapa de Hospitalet de Llobregat, Barcelona - RESTAURAX"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        {/* Por qué contactarnos */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-12 text-center">
              Por qué contactar con RESTAURAX
            </h2>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white rounded-lg p-8 shadow-lg text-center">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-24-hours-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Respuesta inmediata</h3>
                <p className="text-gray-600 leading-relaxed">
                  Atendemos tu llamada 24/7 y nos desplazamos rápidamente a Hospitalet de Llobregat y Barcelona para evaluar los daños y comenzar la restauración.
                </p>
              </div>

              <div className="bg-white rounded-lg p-8 shadow-lg text-center">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-medal-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Más de 15 años de experiencia</h3>
                <p className="text-gray-600 leading-relaxed">
                  Somos expertos en <strong>limpieza de hollín</strong>, <strong>eliminación de olores</strong> y <strong>tratamiento de ozono</strong> con cientos de clientes satisfechos. <Link to="/empresa" className="text-[#F2D70A] hover:text-[#544E13] font-semibold">Conoce nuestra historia</Link>.
                </p>
              </div>

              <div className="bg-white rounded-lg p-8 shadow-lg text-center">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-price-tag-3-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Presupuesto sin compromiso</h3>
                <p className="text-gray-600 leading-relaxed">
                  Evaluación gratuita y presupuesto detallado sin ningún tipo de compromiso. Transparencia total en precios y servicios. <Link to="/servicios" className="text-[#F2D70A] hover:text-[#544E13] font-semibold">Ver todos nuestros servicios</Link>.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-16 bg-gradient-to-br from-[#544E13] to-[#3a3610] text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              No esperes más, contacta con nosotros ahora
            </h2>
            <p className="text-xl mb-8 text-gray-200">
              Cada minuto cuenta tras un incendio. Contacta con RESTAURAX y comienza la recuperación de tu hogar o negocio en Hospitalet de Llobregat con los mejores profesionales de Barcelona.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:690220944"
                className="bg-[#F2D70A] text-[#544E13] px-8 py-4 rounded-lg font-bold text-lg hover:bg-white transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Llamar: 690 22 09 44
              </a>
              <Link 
                to="/servicios"
                className="bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-[#544E13] transition-all whitespace-nowrap cursor-pointer"
              >
                Ver Nuestros Servicios
              </Link>
            </div>
          </div>
        </section>

        <Footer />
        <WhatsAppButton />
        <ScrollToTopButton />
      </div>
    </>
  );
}